import { render, staticRenderFns } from "./CargaAcademica.vue?vue&type=template&id=41c564aa&"
import script from "./CargaAcademica.vue?vue&type=script&lang=js&"
export * from "./CargaAcademica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports